import Navigation from "@/components/Navigation";

const IVTherapy = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-24 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-serif mb-8">IV Therapy</h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div>
              <img
                src="/lovable-uploads/e5351aa9-bbf9-4aee-a3f6-4e7ca2c05b7a.png"
                alt="IV Therapy"
                className="w-full h-[400px] object-cover rounded-lg shadow-lg"
              />
              <div className="grid grid-cols-2 gap-4 mt-4">
                <img
                  src="/lovable-uploads/1305da6d-ce9a-4487-a05a-690946d6097e.png"
                  alt="Treatment 1"
                  className="w-full h-48 object-cover rounded-lg shadow-lg"
                />
                <img
                  src="/lovable-uploads/e6f161f3-ca13-47d7-84ac-cf7618fe16ef.png"
                  alt="Treatment 2"
                  className="w-full h-48 object-cover rounded-lg shadow-lg"
                />
              </div>
            </div>
            <div>
              <p className="text-lg mb-6">
                Revitalize your body with our customized IV therapy treatments. Our expert team delivers targeted nutrients directly to your bloodstream for optimal absorption and results.
              </p>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold mb-2">Vitamin Boost</h3>
                  <p>Enhance your immune system with our vitamin-rich IV formulations.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Hydration Therapy</h3>
                  <p>Rapid rehydration for improved wellness and recovery.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Energy Boost</h3>
                  <p>Specialized IV cocktails to enhance energy and performance.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Recovery & Wellness</h3>
                  <p>Post-workout and wellness-focused IV treatments.</p>
                </div>
              </div>
              <a
                href="https://na02.patientnow.com/a/EVOLVEDYOU"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-primary text-white px-8 py-3 rounded-full text-lg hover:bg-primary/90 transition-colors mt-8"
              >
                Book Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IVTherapy;